// extracted by mini-css-extract-plugin
export default {"container":"SportTeamSeperator_container__DDAU7","border":"SportTeamSeperator_border__GSyb1"};